import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';


export default function relateTaskAutomation(
	state = initialState.relateTaskAutomation,
	action
) {
	switch (action.type) {
		case types.RELATE_TASK_AUTOMATION: 
			return  action.response|| state;
		default:
			return state;
	}
}
